import axios from "axios";

// const OCTOPUS_SERVER = {
//   test: "http://optopus-admin.test.xiaopeng.local/", // 测试
//   release: "https://optopus.cs-pre.xiaopeng.com/", // 预发
//   production: "https://pm.xiaopeng.com/", // 生产
// };

const OCTOPUS_SERVER = {
  test: "http://dsc.test.xiaopeng.local/xp-cs-optopus-admin/", // 测试
  release: "https://dsc.deploy-test.xiaopeng.com/xp-cs-optopus-admin/", // 预发
  production: "https://dsc.xiaopeng.com/xp-cs-optopus-admin/", // 生产
};

axios.defaults.baseURL =
  OCTOPUS_SERVER[process.env.REACT_APP_ENV || ""] || OCTOPUS_SERVER["test"];

// 验证短信链接是否有效
export const verifySmsUrl = (token) => {
  return axios({
    url: `/octopus/cust/h5/verifySmsUrl/${token}`,
    method: "get",
  });
};

// 发送验证码
export const sendVerifyCode = (token, params) => {
  return axios({
    url: `/octopus/cust/h5/sendVerifyCode/${token}`,
    method: "get",
    params,
  });
};

// 校验验证码
export const validateVerifyCode = (token, params) => {
  return axios({
    url: `/octopus/cust/h5/validateVerifyCode/${token}`,
    method: "get",
    params,
  });
};

// 上传文件
export const callbackSmsUrl = (token, params, data) => {
  return axios({
    url: `/octopus/cust/h5/callbackSmsUrl/${token}`,
    method: "post",
    params,
    data,
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  });
};
